import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import FullScreenIllustrationUsageHistory from '../../../domain/entities/FullScreenIllustrationUsageHistory';

export default function reducer(
  state: {[key: number]: FullScreenIllustrationUsageHistory} = {},
  action: AnyAction,
): {[key: number]: FullScreenIllustrationUsageHistory} {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexFullScreenIllustrationUsageHistoriesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: FullScreenIllustrationUsageHistory},
            record: FullScreenIllustrationUsageHistory,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.UpdateFullScreenIllustrationUsageHistorySuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
